import { render } from "./PhaserContent.vue?vue&type=template&id=be1c5504&scoped=true"
import script from "./PhaserContent.vue?vue&type=script&lang=js"
export * from "./PhaserContent.vue?vue&type=script&lang=js"

import "./PhaserContent.vue?vue&type=style&index=0&id=be1c5504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1c5504"]])

export default __exports__